import { VENUE_WARN_COLOR } from '../../live/NetCell';

/**
 * Same palette as `live/NetCell.tsx`. `HEDGED_COLOR` / `UNHEDGED_COLOR` are
 * module-private there (not exported), so the values are mirrored here
 * rather than editing that file — `VENUE_WARN_COLOR` IS exported and is
 * imported directly so the two modules can never drift on that one.
 */
export const HEDGED_COLOR_HEX = '#51cf66';
export const UNHEDGED_COLOR_HEX = '#ff6b6b';
export const VENUE_WARN_COLOR_HEX = VENUE_WARN_COLOR;
